import React from 'react';
import {
    ButtonGroup,
    Avatar,
    SplitCol,
    SplitLayout,
    PanelHeader,
    Chip,
    List,
    Cell,
    PanelHeaderButton, Pagination,
    Spinner, NativeSelect, SimpleCell, Switch, ModalPageHeader, Div
} from '@vkontakte/vkui';
import axios from "axios";
import {Button, Search} from '@vkontakte/vkui';
import {
    Icon16TruckOutline,
    Icon24ShoppingCartOutline,
    Icon16Clear,
    Icon28CloudArrowUpOutline,
    Icon24Story,
    Icon24Cancel,
    Icon20LikeCircleFillGray,
    Icon20LikeCircleFillRed,
    Icon24BrowserBack,
    Icon24Search,
    Icon16SearchOutline,
    Icon28ScissorsOutline,
    Icon28MoneyCircleOutline, Icon24MoneyCircleOutline
} from "@vkontakte/icons";
import Fancybox from "../assets/fancybox";
import {
    AdaptivityContext, checkNarezkaForUral,
    currency_char, getSavedSubdivision,
    formatQnt,
    longDateTimeFormat,
    monitoring_items_key,
    checkCanViewCatalog,
    checkCanViewOst2
} from "../assets/constants";
import cartApi from "../api/CartApi";
import moment from "moment";
import 'moment/locale/ru';
import ParamsFilter from "./ParamsFilter";
import {Icon28SlidersOutline} from '@vkontakte/icons';
import * as constants from "../assets/constants";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import HelpButton from "../assets/HelpButton";

import BaseComponent from "../components/BaseComponent";
import ProductImageCarousel from "../components/ProductImageCarousel";
import AlphabetFilter from "../components/AlphabetFilter";

function ModalPage() {
    return null;
}

function ModalRoot() {
    return null;
}

class MainCatalog extends BaseComponent {

    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "setMonitoringImage") {
                let items = this.state.items_monitoring ? this.state.items_monitoring : {}
                if (items[this.props.current_product.id] == undefined) {
                    items[this.props.current_product.id] = {}
                }
                items[this.props.current_product.id].hasImage = true
                items[this.props.current_product.id].mainImage = event.data.data.image
                items[this.props.current_product.id].thumb = event.data.data.thumb
                items[this.props.current_product.id].datetime = new Date()


                this.setState({items_monitoring: items})
                localStorage.setItem(monitoring_items_key, JSON.stringify(items))
                let old = this.state.items
                if (items && old) {
                    old.map((el, index) => {
                        if (items[el.id] != undefined) {
                            old[index].hasImage = items[el.id].hasImage
                            old[index].mainImage = items[el.id].mainImage
                            old[index].thumb = items[el.id].thumb
                            old[index].datetime = items[el.id].datetime
                        }
                    })
                }
            }

            if (event.data.type == 'qrCodeArrived') {

                const e = {
                    target: {
                        value: event.data.code + '$'
                    }
                }
                this.onSearchChange(e)
            }
            if (event.data.type == 'divisionSelected') {

                this.setState({selectedSubdivision: event.data.value, page: 1})

                setTimeout(() => this.getItems(), 800)
            }
        }
        if (event.data == 'ostatkiGoGetBack') {
            this.backClick()
        }
    }
    searchInterval = null;
    searchAbortController = null;
    searchRequestSeq = 0;
    element = null;

    abortSearchRequest = () => {
        if (this.checkScrollTimeout) {
            clearTimeout(this.checkScrollTimeout);
            this.checkScrollTimeout = null;
        }
        if (this.searchAbortController) {
            this.searchAbortController.abort();
            this.searchAbortController = null;
        }
    }


    constructor(props) {
        super(props)

        this.ref = React.createRef()
        let state = {
            items: [],
            modalHistory: [],
            searchHistory: [],
            selectedSubdivision: null,
            activeModal: null,
            mainSearch: this.props.get_vars && this.props.get_vars.search !== undefined ? this.props.get_vars.search : '',
            showSearch: this.props.get_vars && this.props.get_vars.search !== undefined,
            showSearchHistory: false,
            loading: true,
            page: 1,
            totalItems: 0
        }
        if (this.props.savedState) {
            state = this.props.savedState
        } else {
            const mainSearch = localStorage.getItem(constants.main_search_key)
            if (mainSearch && !state.mainSearch) {
                state.mainSearch = mainSearch
                state.showSearch = true
            }

            const searchHistory = JSON.parse(localStorage.getItem(constants.search_history_key))

            if (searchHistory) {
                state.searchHistory = searchHistory
            }
        }

        state.selectedSubdivision = getSavedSubdivision(this.props.current_user);

        this.state = {
            ...this.state,
            ...state
        }

    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({page: page})
            this.getItems(this.state.mainSearch, false, page)
        }
    }
    goSearch = () => {
        // console.log(state);
        clearInterval(this.searchInterval);

        this.getItems(this.state.mainSearch)
        this.persistMainSearch(this.state.mainSearch)

        this.setState({showSearchHistory: false});
    }
    onSearchChange = (state) => {

        if (state.target.value == '' && this.props.get_vars && this.props.get_vars.search !== undefined) {

            window.postMessage('clearGetVarsSearch')

        }
        clearInterval(this.searchInterval);
        this.abortSearchRequest();
        this.searchRequestSeq += 1;
        this.setState({mainSearch: state.target.value, page: 1, showSearchHistory: true, showSearch: true});
        this.searchInterval = setInterval(() => this.goSearch(), state.target.value == '' ? 500 : 2000);

    }


    getItems = (mainSearch, append, page, letter) => {

        this.setState({loading: true})


        append = append == undefined ? false : append

        clearInterval(this.searchInterval)
        this.abortSearchRequest();
        this.searchAbortController = new AbortController();
        this.searchRequestSeq += 1;
        const requestSeq = this.searchRequestSeq;
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }

        if (page == undefined) {
            page = this.state.page;
        }

        if (mainSearch.length > 2) {
            this.addSearchHistory(mainSearch)
        }

        const body = this.buildSearchBody(mainSearch, page, letter)

        axios.post(this.getSearchUrl(), body,
            {
                withCredentials: true,
                signal: this.searchAbortController.signal

            }
        ).then((response) => {
            if (requestSeq !== this.searchRequestSeq) {
                return
            }
            this.applySearchResponse(response, append)
        }).catch((error) => {
            if (error.code === 'ERR_CANCELED' || axios.isCancel(error)) {
                return
            }
            if (requestSeq !== this.searchRequestSeq) {
                return
            }
            this.setState({loading: false})
        })

    }


    addSearchHistory = (query) => {
        if (!query) return
        query = query.toString().trim()
        let searchHistory = this.state.searchHistory ? [...this.state.searchHistory] : [];

        searchHistory = searchHistory.filter(el => el != query);

        searchHistory.push(query);

        if (searchHistory.length > 7) {
            searchHistory.splice(1, 1)
        }

        this.setState({
            searchHistory
        });
        this.persistSearchHistory(searchHistory)
    }

    persistMainSearch = (value) => {
        localStorage.setItem(constants.main_search_key, value)
    }

    persistSearchHistory = (history) => {
        localStorage.setItem(constants.search_history_key, JSON.stringify(history))
    }

    loadMonitoringItems = () => {
        const data = localStorage.getItem(monitoring_items_key)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_monitoring: items})
        }
    }

    saveMonitoringItems = () => {
        localStorage.setItem(
            monitoring_items_key,
            JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {})
        )
    }

    getSearchUrl = () => {
        return this.props.base_url + '?app=partnersproducts&act=searchProducts'
    }

    buildSearchBody = (mainSearch, page, letter) => {
        let body = new FormData()
        body.append('group', this.props.current_group_id == null ? '' : this.props.current_group_id)
        body.append('sSearch', mainSearch)
        body.append('page', page)
        body.append('epp', AdaptivityContext.isMobile ? 10 : 25)

        if (letter != undefined) {
            body.append('letter', letter)
        }
        if (this.props.parent_product_id != undefined) {
            body.append('parent_product_id', this.props.parent_product_id)
        }

        if (Array.isArray(this.props.current_filter) && this.props.current_filter.length > 0) {
            // eslint-disable-next-line camelcase
            const params_json = JSON.stringify(this.props.current_filter)
            body.append('params', params_json)
        }
        if (this.props.ost2) {
            body.append('ost2', 1)
        }
        if (this.props.ffc_mode) {
            body.append(this.props.current_club.code, 1)
        }
        if (this.props.is_favourites) {
            body.append('is_favourites', 1)
        }
        const validSubdivision = getSavedSubdivision(this.props.current_user)
        if (validSubdivision) {
            body.append('division_id', validSubdivision.external_id)
        }
        return body
    }

    applySearchResponse = (response, append) => {
        this.setState({totalItems: response.data.total});
        this.setState({totalPages: response.data.totalPages});
        this.setState({Alfavit: response.data.Alfavit});
        this.setState({parent_group_id: response.data.parent_group_id});
        let old = this.state.items;
        console.log(this.state.items_monitoring)

        if (!append) {
            old = response.data.results
        } else {
            response.data.results.map((el, i) => {
                old.push(el)
            })
        }

        if (this.props.monitoring_mode && this.state.items_monitoring) {
            old.map((el, index) => {
                if (this.state.items_monitoring[el.id] != undefined) {
                    old[index].hasImage = this.state.items_monitoring[el.id].hasImage
                    old[index].mainImage = this.state.items_monitoring[el.id].mainImage
                    old[index].thumb = this.state.items_monitoring[el.id].thumb
                    old[index].datetime = this.state.items_monitoring[el.id].datetime ? this.state.items_monitoring[el.id].datetime : ''
                    old[index].hasMonitoring = this.state.items_monitoring[el.id].hasMonitoring === true
                }
            })
        }
        this.setState({items: old, loading: false});
        this.setState({path: response.data.path});

        window.postMessage('searchProductsLoaded')

        if (response.data.totalPages > 0) {
            this.checkScrollTimeout = setTimeout(() => {
                this.checkScroll()
            }, 500)
        }
    }

    checkScroll() {
        if (this.state.totalItems * 1 <= this.state.items.length) return
        if (!this.ref.current) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})
            //setTimeout(() => {
            this.getItems(undefined, true, page)
            // }, 500)

        }
    }

    handleScroll() {
        this.checkScroll()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.current_group_id !== this.props.current_group_id
            || prevProps.ffc_mode !== this.props.ffc_mode
            || prevProps.monitoring_mode !== this.props.monitoring_mode
            || prevProps.current_filter !== this.props.current_filter
        ) {
            // Отменяем предыдущий таймаут чтобы избежать дублирования запросов
            if (this.getItemsTimeout) {
                clearTimeout(this.getItemsTimeout);
            }
            clearInterval(this.searchInterval)
            this.abortSearchRequest()
            this.searchRequestSeq += 1

            this.setState({mainSearch: '', loading: true})
            this.persistMainSearch('')
            this.setState({letter: ''})
            this.setState({totalItems: 0})
            this.setState({page: 1})
            this.setState({items: []})

            this.getItemsTimeout = setTimeout(() => {
                this.getItems();
                document.documentElement.scrollTop = document.body.scrollTop = 0
            }, 300)
        }
    }

    componentDidMount = () => {
        super.componentDidMount()
        this.loadMonitoringItems()

        if (!this.props.savedState) {
            this.getItems()
        }

    }
    componentWillUnmount = () => {
        super.componentWillUnmount()
        clearInterval(this.searchInterval)
        this.abortSearchRequest()
        this.searchRequestSeq += 1
        if (this.getItemsTimeout) {
            clearTimeout(this.getItemsTimeout);
        }
        this.saveMonitoringItems()
    }
    changeCurrentGroup = async (item) => {


        if (item === this.props.current_group_id) {
            setTimeout(() => {
                this.getItems('')
            }, 700)
        }
        this.setState({mainSearch: ''})
        this.persistMainSearch('')
        this.setState({letter: ''})
        await this.props.changeCurrentGroup(item)
        this.setState({totalItems: 0})
        this.setState({page: 1})


    }
    setLetter = async (letter) => {

        this.setState({page: 1})
        this.setState({totalItems: 0})
        this.setState({mainSearch: ''})
        this.persistMainSearch('')
        this.setState({letter: letter})

        this.getItems(undefined, false, 1, letter);

    }
    setParentProduct = async (item_id) => {

        this.setState({page: 1})
        this.setState({totalItems: 0})
        this.setState({showSearch: false, mainSearch: ''})
        this.persistMainSearch('')
        this.setState({letter: ''})

        await this.props.changeParentProductId(item_id == null ? null : item_id)

        if (item_id !== null) {
            this.setState({old_group_id: this.props.current_group_id})
            await this.props.changeCurrentGroup('');
        } else {
            await this.props.changeCurrentGroup(this.state.old_group_id);
            this.setState({old_group_id: null})

        }


        setTimeout(() => {
            this.getItems(undefined, false, 1, '');
        }, 300)

    }
    changeCurrentProduct = async (item) => {

        if (this.props.saveState) {
            this.props.saveState(this.state)
        }
        await this.props.changeCurrentProduct(item);
        //   this.props.showSclads();
    };

    getPriceByRequest = (index) => {
        const body = new FormData()
        let olds = this.state.items
        const old = olds[index]
        old.loading_price = true
        old.price = null
        old.price_unit = null
        olds[index] = old

        this.setState({items: olds})
        let sAjaxSource = '/?app=partnersproducts&act=createOstAndPriceRequest';

        const id = old.id
        body.append('product_id', id)
        body.append('sclad_id', [])

        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {
            console.log(response)
            old.loading_price = false
            if (response.data.success == '++ok') {
                let new_price = null;
                let new_unit = null;

                if (response.data.data.Цены != undefined && response.data.data.Цены[0] != undefined) {
                    new_price = response.data.data.Цены[0].price
                    switch (response.data.data.Цены[0].unit) {
                        case old.base_unit.external_id:
                            new_unit = old.base_unit;
                            break
                        case old.pack_unit.external_id:
                            new_unit = old.pack_unit;
                            break
                        case old.unit.external_id:
                            new_unit = old.unit;
                            break
                    }

                    console.log(new_price, new_unit)
                    old.price = new_price
                    old.price_unit = new_unit

                }

            }
            olds[index] = old

            this.setState({items: olds})
        })

    };

    render() {

        if (this.props.ost2) {
            if (!checkCanViewOst2(this.props.current_user)) {
                return (
                    <Div style={{padding: 24, textAlign: 'center'}}>
                        Нет доступа к стендовой программе
                    </Div>
                )
            }
        } else if (!checkCanViewCatalog(this.props.current_user)) {
            return (
                <Div style={{padding: 24, textAlign: 'center'}}>
                    Нет доступа к каталогу
                </Div>
            )
        }

        const images_url = this.props.base_url.replace("frontend/", '');
        this.state.items.map((item, index) => {
            item.cartQnt = 0
            cartApi.items.map((cartEl, j) => {
                if (item.id == cartEl.meta_id) {
                    item.cartQnt += (cartEl.quantity * 1) * cartEl.unit.K / item.base_unit.K
                }
            })
        })
        moment.locale('ru')
        const is_betta_ = this.props.current_user['meta'] && this.props.current_user['meta']['settings'] && this.props.current_user['meta']['settings']['betta_club'] == '1'
        const is_lq = this.props.current_user['meta'] && this.props.current_user['meta']['settings'] && this.props.current_user['meta']['settings']['lq_club'] == '1'
        const main_catalog_modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_PARAMS_FILTER}
                    onClose={this.modalBack}
                    settlingHeight={100}
                    style={{}}
                    header={
                        <ModalPageHeader className="sclads"
                                         right={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                        >

                        </ModalPageHeader>
                    }
                >

                </ModalPage>
            </ModalRoot>
        );

        return ([
            <PanelHeader className={'main-catalog_header ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}
                         before={[<PanelHeaderButton style={{display: 'inline'}} onClick={() => {
                             this.backClick()
                         }} key="cmd_back"><Icon24BrowserBack/></PanelHeaderButton>,
                             AdaptivityContext.isMobile && !this.props.parent_product_id ?
                                 <PanelHeaderButton style={{display: 'inline'}}
                                                    onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : '']}
                         after={
                             [AdaptivityContext.isMobile && this.state.path && !this.state.showSearch && !this.props.ffc_mode ?
                                 <NativeSelect
                                     style={{
                                         zIndex: 23,
                                         marginLeft: '10px',
                                         maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                     }}
                                     value={this.state.path[0].external_id}
                                     onChange={(e) => this.changeCurrentGroup(e.target.value)}
                                 >
                                     {this.state.path.slice().reverse().map((itemP, indexP) => (
                                         <option value={itemP.external_id}>{itemP.name}</option>
                                     ))}
                                 </NativeSelect> : '',
                                 this.props.monitoring_mode && this.state.items_monitoring ?
                                     <Button
                                         onClick={() => this.goToMonitoringCreate()}><Icon28CloudArrowUpOutline/></Button> : '',
                                 AdaptivityContext.isMobile && this.props.current_group_id !== '' ?
                                     <Button mode="secondary" size="l" style={{minWidth: "42px"}}
                                             className="icon-toolbar-btn"
                                             onClick={() => window.postMessage("openParamsFilterModals")}><Icon28SlidersOutline/></Button> : '',
                             ]
                         }

            >

                {this.state.showSearch || !AdaptivityContext.isMobile ?
                    <div>
                        <form onSubmit={(e) => {
                            e.preventDefault()
                            this.goSearch()
                        }}
                        >
                            <Search autoFocus
                                    before={this.state.loading ? <Spinner size="small" style={{maxWidth: '16px'}}/> :
                                        <Icon16SearchOutline/>}
                                    theme="header"
                                    placeholder="Поиск"
                                    autoComplete="off"
                                    onReset={() => this.getItems('')}
                                    value={this.state.mainSearch}
                                    onChange={this.onSearchChange}
                                    onClose={this.toggleSearch}
                                    onBlur={() => setTimeout(() => this.setState({showSearchHistory: false}), 700)}
                                    onClick={() => setTimeout(() => this.setState({showSearchHistory: true}), 700)}
                                    style={{flexGrow: '1', maxWidth: '350px'}}
                            />
                        </form>
                        {this.state.showSearchHistory && (this.state.searchHistory && !this.state.mainSearch || this.state.searchHistory.find((el) => el.toString().toLowerCase().indexOf(this.state.mainSearch.toLowerCase()) !== -1)) ?
                            <div className="autocomplete-wrapper"
                                 style={{minWidth: AdaptivityContext.isMobile ? '200px' : '400px'}}>
                                <List>{this.state.searchHistory.slice().reverse().map((el, index) => {
                                    if (this.state.mainSearch && el.toString().indexOf(this.state.mainSearch) === -1) return
                                    return <Cell onClick={() => {
                                        this.setState({mainSearch: el, page: 1})
                                        setTimeout(() => this.getItems(el), 500)
                                        this.setState({showSearchHistory: false})
                                    }

                                    }>{el}</Cell>
                                })}
                                </List>
                            </div> : ''}
                    </div> : (this.props.ost2 ? 'Стендовая программа' : '')

                }
                {
                    !AdaptivityContext.isMobile && this.state.path /*&& !this.state.showSearch */ && !this.props.ffc_mode ? (
                        <div style={{flexGrow: '2'}}>{
                            this.state.path.slice().reverse().map((itemP) => (
                                [<Button size="s" mode="secondary"
                                         onClick={() => this.changeCurrentGroup(itemP.external_id)}>{itemP.name}</Button>, ' / ']
                            ))}</div>
                    ) : ''
                }</PanelHeader>,

            <SplitLayout modal={main_catalog_modals}>
                {!AdaptivityContext.isMobile && this.props.current_group_id !== '' && this.props.current_group_id !== null && !this.props.ffc_mode ?
                    <SplitCol>
                        <ParamsFilter base_url={this.props.base_url}
                                      current_group_id={this.props.current_group_id}
                                      monitoring_mode={this.props.monitoring_mode}
                                      ffc_mode={this.props.ostatki_club_mode}
                                      parent_product_id={this.props.parent_product_id}
                                      current_filter={this.props.current_filter}
                                      current_filter_items={this.state.current_filter_items}
                        />

                    </SplitCol> : ''}
                <SplitCol width={"50%"}>
                    <AlphabetFilter
                        letters={this.state.Alfavit}
                        onLetterClick={this.setLetter}
                        activeLetter={this.state.letter}
                    />
                    <List style={{marginRight: '28px', marginLeft: '11px'}}>
                        <Fancybox key={'MainCatalogFancyBox'}>
                            {!this.state.loading && Array.isArray(this.state.items)
                                && this.state.items.length === 0 &&
                                <Cell key={'MainCatalogGroup' + 0}>Ничего не найдено</Cell>}
                            {this.state.items.map((item, index) => {
                                    if (item.mainImage != undefined) {
                                        item.mainImage = item.mainImage.replace("\/\/", "\/")
                                    } else {
                                        item.mainImage = ''
                                    }
                                    const narezka = checkNarezkaForUral(item)
                                    const showSticker = is_betta_ && item.is_betta_ || is_lq && item.is_lq
                                    let textSticker = '';
                                    if (showSticker) {
                                        textSticker = `"Монарх" предлагает заработать 70 рублей за каждый проданный квадратный метр ПВХ плитки ${is_betta_ ? 'Betta' : ''}${is_betta_ && is_lq ? ', ' : ''}${is_lq ? 'L\'Quarzo' : ''}. Ваша активность — ваш успех и доход. Верьте в свои силы и достигайте новых результатов вместе с нами!`
                                    }
                                    if (this.props.monitoring_mode) {
                                        return (item.isgroup == '1' ? <Cell key={'MainCatalogGroup' + index}
                                                                            data-index={index}
                                                                            onClick={() => {
                                                                                this.changeCurrentGroup(item.external_id)
                                                                            }}
                                            >
                                                {item.name}

                                            </Cell> :

                                            <div key={'MainCatalogProduct' + index} className="main-catalog_product">
                                                <div className="main-catalog_product-wrapper"
                                                     style={{height: AdaptivityContext.isMobile ? (item.hasImage ? 170 : 142) : 'inherit'}}>
                                                    <div className="main-catalog_product-wrapper_avatar">
                                                        {item.hasImage ? (
                                                            <>
                                                                <a data-fancybox={'gallery' + item.id}
                                                                   href={images_url + item.mainImage.replace('https:/l', 'https://l').replace(images_url, '')}>
                                                                    <Avatar mode="image" style={{borderRadius: '5%'}}
                                                                            size={AdaptivityContext.isMobile ? 140 : 200}
                                                                            src={item.thumb}/>
                                                                </a>
                                                                <ButtonGroup stretched>
                                                                    <Button mode="outline" stretched size="s"
                                                                            onClick={() => {
                                                                                this.changeCurrentProduct(item.id)
                                                                            }}><Icon24Story/></Button>
                                                                    <Button mode="outline" stretched size="s"
                                                                            onClick={() => {
                                                                                this.clearPhoto(index)
                                                                            }}><Icon16Clear/></Button>
                                                                </ButtonGroup>
                                                            </>
                                                        ) : (
                                                            <Avatar mode="image" style={{borderRadius: '5%'}}
                                                                    onClick={() => {
                                                                        this.changeCurrentProduct(item.id)
                                                                    }}
                                                                    size={AdaptivityContext.isMobile ? 140 : 200}
                                                                    src={images_url + constants.EMPTY_IMG}/>
                                                        )}
                                                    </div>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        height: "100%",
                                                        alignItems: "stretch",
                                                        justifyContent: "space-between"
                                                    }}>
                                                        <div
                                                            className={'main-catalog_product-wrapper_name ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}
                                                        >{item.name}
                                                            <hr/>
                                                            <small>{item.datetime ? 'Изображение получено: ' + moment(item.datetime).format(longDateTimeFormat) : ''}</small>
                                                        </div>

                                                        <SimpleCell Component="label" style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            marginBottom: "-12px"
                                                        }} after={<Switch checked={item.hasMonitoring}
                                                                          onChange={(e) => this.changeHasMonitoring(e, index)}/>}>
                                                            Выставка
                                                        </SimpleCell>

                                                    </div>
                                                </div>
                                            </div>)
                                    } else {
                                        return (


                                            item.isgroup == '1' ? <Cell key={'MainCatalogGroup' + index}
                                                                        data-index={index}

                                                    //  indicator={item.address.postcode +', '+item.address.city+', '+item.address.address_1}

                                                                        onClick={() => {
                                                                            this.changeCurrentGroup(item.external_id)
                                                                        }}
                                                >
                                                    {item.name}

                                                </Cell> :

                                                <div key={'MainCatalogProduct' + index} className="main-catalog_product"


                                                >
                                                    <div className="main-catalog_product-wrapper">
                                                        <div className="main-catalog_like-wrapper"
                                                             onClick={() => this.toggleFavourites(item, index)}>{item.like == "1" ?
                                                            <Icon20LikeCircleFillRed/> : <Icon20LikeCircleFillGray/>}</div>


                                                        {narezka && <div
                                                            className={"main-catalog_scissors-wrapper" + (AdaptivityContext.isMobile ? ' mobile' : '')}>
                                                            <Icon28ScissorsOutline/>
                                                        </div>}
                                                        {showSticker && <div
                                                            className={"main-catalog_sticker-wrapper" + (AdaptivityContext.isMobile ? ' mobile' : '')}
                                                            onClick={() => window.postMessage({
                                                                type: 'success',
                                                                text: textSticker,
                                                                timeout: 7000,
                                                                hideSpinner: true
                                                            })}>

                                                            {AdaptivityContext.isMobile ? <Icon24MoneyCircleOutline/> :
                                                                <Icon28MoneyCircleOutline/>}
                                                        </div>}

                                                        <div className="main-catalog_product-wrapper_avatar">
                                                            <ProductImageCarousel
                                                                productId={item.id}
                                                                mainImage={item.mainImage}
                                                                images={item.images}
                                                                imagesUrl={images_url}
                                                                size={AdaptivityContext.isMobile ? 108 : 128}
                                                                isMobile={AdaptivityContext.isMobile}
                                                            />
                                                        </div>

                                                        <div
                                                            className={'main-catalog_product-wrapper_name ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}
                                                            onClick={() => {
                                                                this.changeCurrentProduct(item.id)
                                                            }}> {!(this.props.current_user && this.props.current_user.meta.settings && this.props.current_user.meta.settings.hide_path_docs == '1') && item.qnt2 * 1 > 0 ?
                                                            <Chip style={{background: 'orange', marginRight: '5px'}}
                                                                  removable={false}><Icon16TruckOutline/></Chip> : ''}
                                                            {item.name}
                                                            <CopyToClipBoard text={item.name}
                                                                             style={{position: 'absolute'}}/>
                                                        </div>
                                                        <div
                                                            className={"main-catalog_product-wrapper_right-side " + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                                                            <div
                                                                style={{textAlign: "center"}}>

                                                                {

                                                                    item.isUnique == '0' ? ((item.qnt_View ? item.qnt_View.toString().replace('.000', '') : '') + (item.base_unit ? ' ' + item.base_unit.title : '')) :
                                                                        <HelpButton
                                                                            text="Чтобы увидеть остаток товара - нажмите на название товара"/>

                                                                }</div>
                                                            <Button mode="secondary" style={{
                                                                display: item.num_complect * 1 == 0 ? 'none' : 'inherit',
                                                                flexWrap: 'wrap'
                                                            }} size="s" className="main-catalog_product-wrapper_complect"
                                                                    onClick={() => this.setParentProduct(item.id)}>
                                                                Комплек тующие
                                                            </Button>

                                                            <ButtonGroup mode="horizontal" gap="l"
                                                                         stretched={AdaptivityContext.isMobile}
                                                                         className="main-catalog_product-actions"
                                                                         style={{display: !AdaptivityContext.isMobile ? 'inherit' : 'none'}}>
                                                                {!(this.props.current_user && this.props.current_user.meta.settings && this.props.current_user.meta.settings.hide_prices == '1')
                                                                    &&
                                                                    <Button mode="secondary" size="l"
                                                                            loading={item.loading_price}
                                                                            onClick={() => this.getPriceByRequest(index)}
                                                                            stretched={AdaptivityContext.isMobile}>
                                                                        {item.price && item.price_unit && item.base_unit ? (formatQnt((item.price * item.base_unit.K / item.price_unit.K), false, 2) + currency_char) : 'Цена'}
                                                                    </Button>}

                                                                <Button mode="primary" before={<Icon24ShoppingCartOutline/>}
                                                                        size="l"
                                                                        stretched={AdaptivityContext.isMobile}
                                                                        onClick={() => {
                                                                            this.changeCurrentProduct(item.id)
                                                                        }}
                                                                        after={item.cartQnt > 0 ? item.cartQnt + item.base_unit.title : ''}>
                                                                    В корзину
                                                                </Button>

                                                            </ButtonGroup>
                                                        </div>

                                                    </div>
                                                    <ButtonGroup mode="horizontal" gap="s"
                                                                 stretched={AdaptivityContext.isMobile}
                                                                 className="main-catalog_product-actions"
                                                                 style={{display: AdaptivityContext.isMobile ? 'inherit' : 'none'}}>
                                                        {!(this.props.current_user && this.props.current_user.meta.settings && this.props.current_user.meta.settings.hide_prices == '1')
                                                            &&
                                                            <Button mode="secondary" size="s"
                                                                    loading={item.loading_price}
                                                                    onClick={() => this.getPriceByRequest(index)}
                                                                    stretched={AdaptivityContext.isMobile}>
                                                                {item.price && item.price_unit && item.base_unit ? (formatQnt((item.price * item.base_unit.K / item.price_unit.K), false, 2) + currency_char) : 'Цена'}
                                                            </Button>}

                                                        <Button mode="primary" before={<Icon24ShoppingCartOutline/>}
                                                                size="s"
                                                                stretched={AdaptivityContext.isMobile} onClick={() => {
                                                            this.changeCurrentProduct(item.id)
                                                        }}
                                                                after={item.cartQnt > 0 ? item.cartQnt + item.base_unit.title : ''}>
                                                            В корзину
                                                        </Button>

                                                    </ButtonGroup>
                                                </div>

                                        )
                                    }
                                }
                            )}

                        </Fancybox>
                    </List>
                    {AdaptivityContext.isMobile ?
                        <div ref={this.ref} key="loader"
                             style={{height: '50px', width: 'auto'}}>{this.state.loading &&
                            <Spinner size="large"/>}</div> :
                        this.state.loading &&
                        <div key="loader"
                             style={{height: '50px', width: 'auto'}}><Spinner size="large"/></div>}
                </SplitCol>
            </SplitLayout>,
            this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", left: "0", zIndex: '99'}}>
                    <Pagination currentPage={this.state.page}
                                totalPages={this.state.totalPages}
                                onChange={this.setPage}/>
                </div> : ''
        ]);
    }

    backClick = () => {
        if (Array.isArray(this.props.current_filter) && this.props.current_filter.length > 0) {
            window.postMessage({type: "applyCurrentFilter", value: {filters: [], items: []}})
        } else if (this.props.current_group_id == '' && this.props.parent_product_id != null) {
            this.setParentProduct(null)
        } else {
            if (this.state.parent_group_id !== this.props.current_group_id) {
                this.changeCurrentGroup(this.state.parent_group_id)
            } else {
                window.postMessage('goGetBack')
            }
        }
    }

    changeHasMonitoring = (e, index) => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}
        let old = this.state.items
        let current_product = this.state.items[index]
        if (items[current_product.id] == undefined) {
            items[current_product.id] = {}
        }
        items[current_product.id].hasMonitoring = e.target.checked
        old[index].hasMonitoring = e.target.checked

        this.setState({items_monitoring: items})
        this.setState({items: old})
        localStorage.setItem(monitoring_items_key, JSON.stringify(items))
    }

    clearPhoto = (index) => {
        let items = this.state.items_monitoring ? this.state.items_monitoring : {}
        let old = this.state.items
        let current_product = this.state.items[index]
        if (items[current_product.id] == undefined) {
            items[current_product.id] = {}
        }
        items[current_product.id].hasImage = false
        old[index].hasImage = false

        this.setState({items_monitoring: items})
        this.setState({items: old})
        localStorage.setItem(monitoring_items_key, JSON.stringify(items))
    }

    goToMonitoringCreate = () => {
        window.postMessage('goToMonitoringCreate')
    }

    addToFavourites = (item, index) => {

        let body = new FormData()

        body.append('product_id', item.id)


        axios.post(this.props.base_url + '?app=partnersproducts&act=addToFavourites', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            if (response.data.success) {
                let items = this.state.items;
                items[index].like = '1'
                this.setState({items})
                window.postMessage('checkFavourites')
            }
        })

    }
    removeFromFavourites = (item, index) => {

        let body = new FormData()

        body.append('product_id', item.id)


        axios.post(this.props.base_url + '?app=partnersproducts&act=removeFromFavourites', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            if (response.data.success) {
                let items = this.state.items;
                items[index].like = '0'
                this.setState({items})
                window.postMessage('checkFavourites')
            }
        })

    }

    toggleFavourites = (item, index) => {
        if (item.like === '0') {
            this.addToFavourites(item, index)
        } else {
            this.removeFromFavourites(item, index)
        }
    }
}

export default MainCatalog;
